import { useLDFlags } from './LD/useLDFlags';

export const useNewProfileAndMembershipFlag = () => {
  const flags = useLDFlags();
  const newProfileAndMembershipPagesFlag =
    flags['release-new-profile-and-membership-pages'];

  return newProfileAndMembershipPagesFlag === undefined
    ? undefined
    : newProfileAndMembershipPagesFlag === 'enabled';
};
